import React, { useState, useEffect } from 'react';
import { makeStyles, CircularProgress, Grid } from '@material-ui/core';
import { BoxWrapper } from 'components/Base';
import { getCachableData } from './utils';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import Store from 'store/store';
import api from 'api';
import CountryBreakdownChart from './CountryBreakdownChart';

const { selectors, actions } = Store;

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '25rem'
  }
});

const CountryBreakdown = ({
  investments,
  countryBreakdown,
  setCachedCountryBreakdown,
  countryBreakdownCacheIsValid,
  selectedInvestment
}: any) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(
    !countryBreakdown.investments.length
  );

  useEffect(() => {
    getCachableData(
      investments,
      countryBreakdownCacheIsValid,
      setIsLoading,
      () => api.getResearchItemCountryBreakdown(selectedInvestment),
      setCachedCountryBreakdown
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [investments]);

  return (
    <>
      {isLoading ? (
        <div className={classes.loaderWrapper}>
          <CircularProgress size="80px" />
        </div>
      ) : (
        <Grid
          container
          spacing={2}
          style={{ display: 'flex', alignItems: 'stretch' }}
        >
          {investments.map((fund: any) => {
            const prefix = fund.type === 'f' ? 'f' : 'mp';
            return (
              <Grid item xs={12} md={6} key={fund.id}>
                <BoxWrapper title={fund.name} style={{ height: '100%' }}>
                  <CountryBreakdownChart
                    data={(
                      countryBreakdown.data[`${prefix}-${fund.id}`] || []
                    ).map((allocation: any) => ({
                      name: allocation.name,
                      value: Number(allocation.value) * 100,
                      equity: Number(allocation.equity) * 100,
                      fixed_income: Number(allocation.fixed_income) * 100
                    }))}
                  />
                </BoxWrapper>
              </Grid>
            );
          })}
        </Grid>
      )}
    </>
  );
};

export default compose(
  connect(
    (state: any) => ({
      investments:
        selectors.investmentAnalyserSelectors.checkedResearchInvestments(state),
      countryBreakdown:
        selectors.investmentAnalyserSelectors.countryBreakdown(state),
      countryBreakdownCacheIsValid:
        selectors.investmentAnalyserSelectors.countryBreakdownCacheIsValid(
          state
        )
    }),
    {
      setCachedCountryBreakdown:
        actions.investmentAnalyserActions.updateCountryBreakdown
    }
  )
)(CountryBreakdown);
